/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Due_Date_TitleInputs */

const en_explorer_info_due_date_title = /** @type {(inputs: Explorer_Info_Due_Date_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Due Date`)
};

const fr_explorer_info_due_date_title = /** @type {(inputs: Explorer_Info_Due_Date_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Due Date`)
};

const de_explorer_info_due_date_title = /** @type {(inputs: Explorer_Info_Due_Date_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Due Date`)
};

const it_explorer_info_due_date_title = /** @type {(inputs: Explorer_Info_Due_Date_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Due Date`)
};

const ru_explorer_info_due_date_title = /** @type {(inputs: Explorer_Info_Due_Date_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Due Date`)
};

const es_explorer_info_due_date_title = /** @type {(inputs: Explorer_Info_Due_Date_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Due Date`)
};

const zh_cn2_explorer_info_due_date_title = /** @type {(inputs: Explorer_Info_Due_Date_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Due Date`)
};

const ja_explorer_info_due_date_title = /** @type {(inputs: Explorer_Info_Due_Date_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Due Date`)
};

const hi_explorer_info_due_date_title = /** @type {(inputs: Explorer_Info_Due_Date_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Due Date`)
};

const pt_pt2_explorer_info_due_date_title = /** @type {(inputs: Explorer_Info_Due_Date_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Due Date`)
};

/**
* | output |
* | --- |
* | "Set Due Date" |
*
* @param {Explorer_Info_Due_Date_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_due_date_title = /** @type {((inputs?: Explorer_Info_Due_Date_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Due_Date_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_due_date_title(inputs)
	if (locale === "de") return de_explorer_info_due_date_title(inputs)
	if (locale === "it") return it_explorer_info_due_date_title(inputs)
	if (locale === "ru") return ru_explorer_info_due_date_title(inputs)
	if (locale === "es") return es_explorer_info_due_date_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_due_date_title(inputs)
	if (locale === "ja") return ja_explorer_info_due_date_title(inputs)
	if (locale === "hi") return hi_explorer_info_due_date_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_due_date_title(inputs)
	return en_explorer_info_due_date_title(inputs)
});